let internal_firebase_config = null;
let monthly_recurly_plan;
let annual_recurly_plan;
let internal_recurly_base_url;
let internal_recurly_public_key;

if (window.location.hostname.indexOf('actionableagile-for-azure.55degrees-apps.net') > -1) {
  monthly_recurly_plan = 'aa-azure-monthly';
  annual_recurly_plan =  'aa-azure-yearly';
  internal_recurly_public_key = 'ewr1-3Gh6j5LPld4HlivOW8jWjT';
  internal_recurly_base_url = 'https://55degrees.recurly.com';
} else {
  monthly_recurly_plan = 'azure-monthly-dev-plan';
  annual_recurly_plan =  'azure-annual-dev-plan';
  internal_recurly_public_key = 'ewr1-0oarnVplgUNjELkQVUw0NV';
  internal_recurly_base_url = 'https://55degrees-dev.recurly.com';
}

export const firebase_config = internal_firebase_config;
export const recurly_base_url = internal_recurly_base_url;
export const recurly_public_key = internal_recurly_public_key;
export const recurly_plans = { "monthly": monthly_recurly_plan, "annual":annual_recurly_plan};
